export const errorMessage = {
  minDate: "The date must be at least 1 day in the future",
  passwordNotEqual: "Both passwords are not identical",
  passwordComplexity: "Password must contain at least 8 characters",
  phoneFormat: "Must be a valid 10 digits phone number",
  required: "This field is required",
};

export const errorCode = {
  minDate: "minDate",
  minLength: "minlength",
  passwordNotEqual: "passwordNotEqual",
  pattern: "pattern",
  notBoolean: "notBoolean",
  notNumber: "notNumber",
  notPhoneNumber: "notPhoneNumber",
  required: "required",
};

function getBaseError(formError: object): string | undefined {
  if (errorCode.required in formError) {
    return errorMessage.required;
  }
}

export function getDateError(formError: object | null | undefined): string | undefined {
  if (!formError) {
    return;
  }
  if (errorCode.minDate in formError) {
    return errorMessage.minDate;
  } else {
    return getBaseError(formError);
  }
}

export function getPasswordError(formError: object | null | undefined): string | undefined {
  if (!formError) {
    return;
  }
  if (errorCode.minLength in formError) {
    return errorMessage.passwordComplexity;
  } else if (errorCode.passwordNotEqual in formError) {
    return errorMessage.passwordNotEqual;
  } else {
    return getBaseError(formError);
  }
}

export function getPhoneError(formError: object | null | undefined): string | undefined {
  if (!formError) {
    return;
  }
  if (errorCode.notPhoneNumber in formError) {
    return errorMessage.phoneFormat;
  } else if (errorCode.pattern in formError) {
    return errorMessage.phoneFormat;
  }
}
